import React from 'react';

import styled from 'styled-components';

import media from 'theme/media';

import { LightIcon } from '../../common/fromAuth/LightIcon/LightIcon';
import { PromoRow } from '../../common/PromoRow/PromoRow';
import PromoInputWrapper from '../PromoInputWrapper';

export const SearchIconWrap = styled.div`
    margin-right: 16px;

    ${media.desktop1920} {
        margin-right: 24px;
    }
`;

const focus = (e) => {
    if (e.currentTarget) {
        const input = e.currentTarget.firstElementChild;
        input.focus();
    } else {
        if (__isDev__) {
            console.log('Focus method not support');
        }
    }
};

export const PromoInputSearch = (props) => {
    return (
        <PromoRow indent="32px" onClick={(e) => props.toggle(e, true)}>
            <PromoInputWrapper
                name="search"
                setFocus={focus}
                leftInputComponent={
                    <SearchIconWrap>
                        <LightIcon name="search" color="mediumGray" />
                    </SearchIconWrap>
                }
            >
                <input type="search" placeholder={props.placeholder} autoFocus={props.autoFocus} />
            </PromoInputWrapper>
        </PromoRow>
    );
};
